import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
/**
 * @description Данный хук предоставляет возможность тогглить состояние стейта
 *
 * @param {boolean} [initialState=false] - Начальное состояние для стейта
 * @return {{toggle: VoidFunction, state: boolean}}
 */

export function useToggleState() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _React$useState = React.useState(initialState),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      state = _React$useState2[0],
      setState = _React$useState2[1];

  var toggle = React.useCallback(function () {
    return setState(function (st) {
      return !st;
    });
  }, []);
  return {
    state: state,
    toggle: toggle
  };
}